import { createPortal } from 'react-dom';
import styles from './modal.module.css';
import { ModalOverlay } from '../ModalOverlay/ModalOverlay';
import { FC, ReactNode, useEffect } from 'react';
import loading from '../../images/loading.gif'

const modalContainer = document.querySelector('#modal')

interface IModal {
    close: () => void;
    children: ReactNode;
    isLoading: boolean;
}

export const Modal: FC<IModal> = ({close, children, isLoading}) => {

    const escClose = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            close()
        }
    } 

    useEffect(() => {
        document.addEventListener('keydown', escClose)
        return (() => {
            document.removeEventListener('keydown', escClose)
        })
    })


    return createPortal(
        <>
        {
              <div 
              className={styles.container}
              // style={{backgroundImage: `url(${doge.backgroundImagePopup})`}}
              >
                {children}
              </div>
        }
          <ModalOverlay />
        </>,
        modalContainer as Element
      )
    }